import request, { ResponseData } from '@/utils/request'

// 获取快捷短语列表
export async function phraseList(params) {
  return request('/api/v1/sys/phrase/list', {
    method: 'post',
    data: params,
  })
}

// 删除快捷短语
export async function deletePhrase(params) {
  return request('/api/v1/sys/phrase/del', {
    method: 'post',
    data: params,
  })
}

// 导入快捷短语2.0
export async function ImportPhraseDownloadCenter(params) {
  return request('/api/v1/sys/phrase/upload_url', {
    method: 'post',
    data: params,
  })
}

// 获取分组
export async function fetchGroupList(params) {
  return request('/api/v1/user_group/query', {
    method: 'post',
    data: params,
  })
}

// 新建用户组
export async function createGroup(params) {
  return request('/api/v1/user_group/create', {
    method: 'post',
    data: params,
  })
}

// 新建用户组
export async function editGroup(params) {
  return request('/api/v1/user_group/update', {
    method: 'post',
    data: params,
  })
}

export async function deleteGroup(params) {
  return request('/api/v1/user_group/delete', {
    method: 'post',
    data: params,
  })
}

export async function batchDeleteGroup(params) {
  return request('/api/v1/user_group/batch_delete', {
    method: 'post',
    data: params,
  })
}

export async function clearPhrase() {
  return request('/api/v1/sys/phrase/clear_all', {
    method: 'post',
  })
}

// 快捷短语分组创建
export async function addGroup(params) {
  return request('/api/v1/sys/phrase/group/save', {
    method: 'post',
    data: params,
  })
}

// 获取用户组用户
export async function shortListByPage(params) {
  return request('/api/v1/user_group/get_users', {
    method: 'post',
    data: params,
  })
}

// 获取用户组详情
export async function getUserGroup(params) {
  return request(`/api/v1/user_group/get?id=${params.id}`, {
    method: 'get',
  })
}
